import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {FormattedMessage, injectIntl} from 'react-intl'

import LanguageSelector from './LanguageSelector.js'

class NavBar extends Component {
  render () {
    const {locale} = this.props
    return (
      <nav>
        <ul>
          <li>
            <Link to={`/${locale}/`}>
              <FormattedMessage id='homeButton' />
            </Link>
          </li>
          <li>
            <Link to={`/${locale}/albums/`}>
              <FormattedMessage id='albumsButton' />
            </Link>
          </li>
          <li>
            <LanguageSelector />
          </li>
        </ul>
      </nav>
    )
  }
}

export default injectIntl(NavBar)



// WEBPACK FOOTER //
// ./src/NavBar.js